module.exports = __webpack_public_path__ + "img/disableddelete.90adc103.svg";